var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 443,
    viewBox: "0 0 257 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.352 377.858C180.893 378.275 182.263 378.638 183.738 378.941L175.02 376.604C176.448 377.079 177.986 377.492 179.352 377.858Z",
    fill: "url(#paint0_linear_740_5482)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.426 88.8321C299.313 78.185 282.167 70.0175 263.189 64.9273C244.378 59.8859 225.271 58.3413 206.867 60.0059L314.426 88.8321Z",
    fill: "url(#paint1_linear_740_5482)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.703 69.3154L345.59 117.53C341.655 112.715 337.351 108.265 332.826 103.936L183.376 63.8827C177.301 65.3709 171.407 67.1836 165.703 69.3154Z",
    fill: "url(#paint2_linear_740_5482)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_5482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: -1,
    width: 227,
    height: 227
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.273 82.8389L280.755 -0.000305176L363.059 142.554L219.577 225.393L137.273 82.8389Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_5482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.387 82.3406L362.733 142.47C360.462 138.285 357.872 134.291 355.274 130.294L150.936 75.5308C146.626 77.5839 142.446 79.8521 138.387 82.3406Z",
    fill: "url(#paint3_linear_740_5482)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_740_5482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 0,
    width: 261,
    height: 260
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.465 95.4287L280.223 0.305725L375.118 164.669L210.36 259.792L115.465 95.4287Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_740_5482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.57 97.1043L373.38 165.667C372.03 161.82 370.395 157.994 368.656 154.227L127.319 89.4561C123.99 91.9523 120.664 94.4533 117.57 97.1043Z",
    fill: "url(#paint4_linear_740_5482)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.965 112.908L379.689 187.607C378.849 183.902 377.969 180.365 377.018 176.718L108.787 104.927C106.082 107.499 103.44 110.179 100.965 112.908Z",
    fill: "url(#paint5_linear_740_5482)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7352 129.796L382.705 208.854C382.441 205.39 382.005 201.881 381.572 198.377L93.9571 121.295C91.7624 124.007 89.7441 126.762 87.7352 129.796Z",
    fill: "url(#paint6_linear_740_5482)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2849 147.251L383.028 229.188C383.214 225.761 383.293 222.39 383.263 219.082L82.1379 138.379C80.4583 141.229 78.8415 144.188 77.2849 147.251Z",
    fill: "url(#paint7_linear_740_5482)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2924 165.451L380.849 248.953C381.44 245.715 381.858 242.439 382.28 239.16L72.9464 156.261C71.6702 159.307 70.5057 162.296 69.2924 165.451Z",
    fill: "url(#paint8_linear_740_5482)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8085 179.463C64.3965 181.001 64.0474 182.647 63.6382 184.19L376.386 268.008C376.798 266.47 377.319 264.869 377.733 263.324C378.145 261.786 378.494 260.14 378.906 258.602L66.1579 174.784C65.7412 176.325 65.2205 177.925 64.8085 179.463Z",
    fill: "url(#paint9_linear_740_5482)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.259 203.626L369.591 286.532C370.864 283.481 372.14 280.435 373.247 277.335L61.6932 193.837C61.1619 197.179 60.6814 200.347 60.259 203.626Z",
    fill: "url(#paint10_linear_740_5482)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2809 223.709L360.406 304.412C362.086 301.562 363.703 298.603 365.257 295.535L59.5134 213.598C59.3302 217.03 59.2511 220.401 59.2809 223.709Z",
    fill: "url(#paint11_linear_740_5482)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9724 244.414L348.587 321.496C350.777 318.786 352.846 315.857 354.806 312.99L59.7299 234C60.0571 237.572 60.4275 240.968 60.9724 244.414Z",
    fill: "url(#paint12_linear_740_5482)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6329 266.004L333.924 337.911C336.634 335.337 339.273 332.652 341.681 329.817L62.8527 255.178C63.6274 258.782 64.5757 262.424 65.6329 266.004Z",
    fill: "url(#paint13_linear_740_5482)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8879 288.563L315.333 353.271C318.722 350.879 321.88 348.337 325.143 345.727L69.2266 277.233C70.6853 281.016 72.2115 284.905 73.8879 288.563Z",
    fill: "url(#paint14_linear_740_5482)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_740_5482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 217,
    width: 227,
    height: 226
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5078 299.802L222.838 217.05L305.38 360.016L162.049 442.768L79.5078 299.802Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_740_5482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4412 312.537L291.782 367.305C296.09 365.247 300.27 362.979 304.329 360.491L79.8086 300.322C82.1886 304.444 84.7375 308.608 87.4412 312.537Z",
    fill: "url(#paint15_linear_740_5482)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.65 338.744L259.273 378.843C265.355 377.357 271.244 375.547 277.013 373.516L96.957 325.261C100.998 330.008 105.196 334.526 109.65 338.744Z",
    fill: "url(#paint16_linear_740_5482)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.055 353.85C141.995 363.722 157.777 371.528 175.019 376.605L183.738 378.942C201.207 383.168 218.772 384.303 235.782 382.717L128.055 353.85Z",
    fill: "url(#paint17_linear_740_5482)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_5482",
    x1: 178.103,
    y1: 378.992,
    x2: 182.311,
    y2: 376.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_5482",
    x1: 244.904,
    y1: 89.4536,
    x2: 296.817,
    y2: 59.4647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_5482",
    x1: 229.318,
    y1: 118.567,
    x2: 316.14,
    y2: 68.4131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_5482",
    x1: 217.721,
    y1: 143.743,
    x2: 326.023,
    y2: 81.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_5482",
    x1: 207.98,
    y1: 166.296,
    x2: 332.52,
    y2: 94.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_5482",
    x1: 199.507,
    y1: 187.726,
    x2: 336.099,
    y2: 108.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_740_5482",
    x1: 191.977,
    y1: 208.463,
    x2: 337.15,
    y2: 124.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_740_5482",
    x1: 185.317,
    y1: 228.37,
    x2: 336.352,
    y2: 141.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_740_5482",
    x1: 179.368,
    y1: 247.734,
    x2: 333.786,
    y2: 158.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_740_5482",
    x1: 174.121,
    y1: 266.427,
    x2: 329.609,
    y2: 176.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_740_5482",
    x1: 169.52,
    y1: 284.498,
    x2: 323.938,
    y2: 195.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_740_5482",
    x1: 165.623,
    y1: 301.901,
    x2: 316.658,
    y2: 214.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_740_5482",
    x1: 162.52,
    y1: 318.414,
    x2: 307.693,
    y2: 234.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_740_5482",
    x1: 160.328,
    y1: 334.162,
    x2: 296.916,
    y2: 255.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_740_5482",
    x1: 159.091,
    y1: 348.677,
    x2: 283.714,
    y2: 276.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_740_5482",
    x1: 159.22,
    y1: 361.813,
    x2: 267.586,
    y2: 299.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_740_5482",
    x1: 160.631,
    y1: 374.557,
    x2: 247.536,
    y2: 324.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_740_5482",
    x1: 166.151,
    y1: 383.342,
    x2: 218.147,
    y2: 353.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines2);
export default __webpack_public_path__ + "static/media/lines2.e9466fa74cdb3615db50ac42eec94e81.svg";
export { ForwardRef as ReactComponent };